import get from "lodash/get";

const geometryConfig = {
  fer: {
    displayName: "FER",
    geojsonUrl:
      process.env.PUBLIC_URL + "/data/fer-updated-4-oct-2022-topo.json",
    idSelector: (feature) => get(feature, ["properties", "ID"]),
    idCol: "ID",
    nameSelector: (feature) => get(feature, ["properties", "Functional"]),
    topologyObjectsName: "FER",
  },
  regions: {
    displayName: "DPC Regions",
    geojsonUrl:
      process.env.PUBLIC_URL +
      "/data/dpc-regions-generalised-simplified-0.0008-topo.json",
    idSelector: (feature) => get(feature, ["properties", "CADID"]),
    idCol: "CADID",
    nameSelector: (feature) => get(feature, ["properties", "REGION"]),
    topologyObjectsName: "dpc-regions-generalised-simplified-0",
  },
};

export default geometryConfig;



// WEBPACK FOOTER //
// ./src/modules/geometryConfigs.js